export const MAX_NUMBER_OF_PAGE_BOXES_WITHOUT_DOTS = 7;

export const INITIAL_PAGE = 1;
